import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  orangeCardHeader,
  redCardHeader,
  yellowCardHeader,
  greenCardHeader,
  primaryCardHeader,
  roseCardHeader,
} from 'assets/jss/material-dashboard-react.jsx'
const cardIconStyle = {
  cardIcon: {
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$greenCardHeader,&$orangeCardHeader,&$redCardHeader,&$yellowCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader':
      {
        borderRadius: '3px',
        backgroundColor: '#999',
        padding: '15px',
        marginTop: '-20px',
        marginRight: '15px',
        float: 'left',
      },
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  orangeCardHeader,
  redCardHeader,
  yellowCardHeader,
  infoCardHeader,
  greenCardHeader,
  primaryCardHeader,
  roseCardHeader,
}

export default cardIconStyle
